// extracted by mini-css-extract-plugin
export default {"icon":"EanIndicator_icon__5i0ri","wrapper":"EanIndicator_wrapper__AyqC3"};